
export const SpinnerIndicator = ({ active, margin = "" }) => {
  return active && (<div className={`text-center ${margin}`}>
    <div className="spinner-border" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>);
};